module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "sidebar"
  }, [_c('ul', {
    staticClass: "sidebar-menu",
    attrs: {
      "id": "menuArea"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', {
      staticClass: "treeview",
      attrs: {
        "data-ref": item.ref
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), (item.childrens) ? _c('ul', {
      staticClass: "treeview-menu"
    }, _vm._l((item.childrens), function(subitem) {
      return _c('li', {
        class: subitem.childrens ? 'treeview-sub' : '',
        attrs: {
          "data-pref": item.ref,
          "data-ref": subitem.ref
        }
      }, [(subitem.childrens) ? _c('a', {
        attrs: {
          "href": "#"
        }
      }, [_c('i', {
        class: subitem.icon
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(subitem.name))]), _vm._v(" "), _vm._m(1, true)]) : _c('router-link', {
        attrs: {
          "to": subitem.href
        }
      }, [_c('i', {
        class: subitem.icon
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(subitem.name))])]), _vm._v(" "), (subitem.childrens) ? _c('ul', {
        staticClass: "treeview-menu"
      }, _vm._l((subitem.childrens), function(childitem) {
        return _c('li', {
          class: childitem.childrens ? 'treeview-sub' : '',
          attrs: {
            "data-pref": subitem.ref,
            "data-ref": childitem.ref
          }
        }, [(childitem.childrens) ? _c('a', {
          attrs: {
            "href": "#"
          }
        }, [_c('i', {
          class: childitem.icon
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(childitem.name))]), _vm._v(" "), _vm._m(2, true)]) : _c('router-link', {
          attrs: {
            "to": childitem.href
          }
        }, [_c('i', {
          class: childitem.icon
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(childitem.name))])])], 1)
      }), 0) : _vm._e()], 1)
    }), 0) : _vm._e()])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-19d22647!./~/vue-loader/lib/selector.js?type=template&index=0!./src/part/system/menu.vue
// module id = 1209
// module chunks = 105